// src/pages/Favourites.js
import { useEffect, useState } from "react";
import { useAuth } from "./AuthContext";
import { db } from "./firebase";
import { collection, getDocs } from "firebase/firestore";
import Technique from "./components/TechniqueCard"; // Adjust if yours is called TechniqueCard or similar
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTopButton from "./components/ScrollToTop";


export default function Favourites() {
  const user = useAuth();
  const [favourites, setFavourites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showScrollButton, setShowScrollButton] = useState(false);


  useEffect(() => {
    if (!user) return;

    const fetchFavourites = async () => {
      const favsRef = collection(db, "users", user.uid, "favourites");
      const favSnap = await getDocs(favsRef);
      const favList = favSnap.docs.map((doc) => doc.data());
      setFavourites(favList);
      setLoading(false);
    };

    fetchFavourites();
  }, [user]);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setShowScrollButton(true);
      } else {
        setShowScrollButton(false);
      }
    };
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  if (!user) {
    return <p>Please log in to view your favourites.</p>;
  }

  return (
    <>
      <Header />
      <div className="app-container">
        <h1>Your Favourites</h1>
        {loading ? (
          <p>Loading...</p>
        ) : favourites.length === 0 ? (
          <p>You haven’t saved any favourites yet.</p>
        ) : (
          <div className="technique-list">
            {favourites.map((tech) => (
              <Technique
                key={tech.url}
                technique={tech}
                isExpanded={false}
                onExpand={() => {}}
              />
            ))}
          </div>
        )}
      </div>
      {showScrollButton && <ScrollToTopButton />}
      <Footer />
    </>
  );
}
